<template>
  <v-card v-if="canViewBookshelf" class="pa-2">
    <v-card-title
      v-if="wallTitle !== ''"
      class="headline"
      style="justify-content: center;"
    >
      {{ wallTitle }}
    </v-card-title>

    <v-card-text>
      <template v-if="!isUnEditedWall">
        <div v-if="wallPublicationType !== 'private'">
          {{ lang.BookshelfShare.share }}
        </div>
        <vc-share-a
          v-if="wallPublicationType !== 'private'"
          :href="wallUrl"
          :class="[$style.linkTextDecoration, 'subheading']"
          target="_blank"
        >
          {{ wallUrl }}
        </vc-share-a>
        <vc-share-icons
          v-if="wallPublicationType === 'public'"
          :twitter-text="wallTitle"
          :twitter-hash-tags="twitterHashTags"
          :line-text="wallTitle"
          :src-url="wallUrl"
          :lang="lang.ShareIcons"
          :show-japanese-web-site="locale === 'ja-jp'"
        ></vc-share-icons>
        <vc-share-icons
          v-if="wallPublicationType === 'secret_word'"
          twitter-text="*****"
          :twitter-hash-tags="twitterHashTags"
          line-text="*****"
          :src-url="wallUrl"
          :lang="lang.ShareIcons"
          :show-japanese-web-site="locale === 'ja-jp'"
        ></vc-share-icons>
      </template>
      <template v-else>
        <div class="text-xs-center">{{ lang.BookshelfShare.description }}</div>
      </template>
    </v-card-text>

    <v-card-actions class="pa-4" style="justify-content: center;">
      <v-btn
        color="success"
        large
        :class="[$style.btnSize, 'subheading']"
        :href="wallPublicationSettingsUrl"
        :loading="isLoading"
      >
        <template v-if="isUnEditedWall">
          {{ lang.BookshelfShare.publish_btn_text }}
        </template>
        <template v-else>
          {{ lang.BookshelfShare.edit_btn_text }}
        </template>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "vc-share-star-contents-publish",
  props: {
    lang: {
      type: Object,
      default: () => {
        return {
          BookshelfShare: {},
          ShareIcons: {}
        };
      }
    },
    locale: {
      type: String,
      default: ""
    },
    wallTitle: {
      type: String,
      default: ""
    },
    wallDescription: {
      type: String,
      default: ""
    },
    isUnEditedWall: {
      type: Boolean,
      default: true
    },
    wallUrl: {
      type: String,
      default: ""
    },
    wallPublicationSettingsUrl: {
      type: String,
      default: ""
    },
    twitterHashTags: {
      type: String,
      default: ""
    },
    wallPublicationType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    canViewBookshelf() {
      return (
        typeof window.WebAssembly === "object" &&
        typeof window.WebAssembly.Memory === "function"
      );
    }
  }
};
</script>

<style module lang="scss">
.btnSize {
  min-width: 165px;
  min-height: 48px;
}
.linkTextDecoration {
  text-decoration: none;
}
.helpIconParentPosition {
  position: relative;
}
.helpLinkArea {
  position: absolute;
  top: -13px;
  left: 5px;
  width: 48px;
  height: 48px;
}

.helpIconPosition {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  fill: gray;
}
</style>
